import { CompareRangeType } from "src/types/enum/CompareRangeType";

export enum AutoRulesComparePeriodEnum {
    lastWeek = "lastWeek",
    lastTwoWeeks = "lastTwoWeeks",
    lastFourWeeks = "lastFourWeeks",
    monthLastYear = "monthLastYear",
    weekLastYear = "weekLastYear",
    selection = "selection",
}

const AUTO_RULES_COMPARE_PERIOD_TO_COMPARE_RANGE_TYPE_MAP: Record<
    AutoRulesComparePeriodEnum,
    CompareRangeType
> = {
    [AutoRulesComparePeriodEnum.lastWeek]: CompareRangeType.lastWeek,
    [AutoRulesComparePeriodEnum.lastTwoWeeks]: CompareRangeType.lastTwoWeeks,
    [AutoRulesComparePeriodEnum.lastFourWeeks]: CompareRangeType.lastFourWeeks,
    [AutoRulesComparePeriodEnum.monthLastYear]: CompareRangeType.monthLastYearDateToDate,
    [AutoRulesComparePeriodEnum.weekLastYear]: CompareRangeType.weekLastYearTantamount,
    [AutoRulesComparePeriodEnum.selection]: CompareRangeType.selectionTantamount,
};

export function mapComparePeriodToRangeType(
    comparePeriod: AutoRulesComparePeriodEnum
): CompareRangeType {
    return AUTO_RULES_COMPARE_PERIOD_TO_COMPARE_RANGE_TYPE_MAP[comparePeriod];
}
